<div fxFlex="100" fxLayout="column" *ngIf="(globalContext$ | async) as globalContext">

  <mat-form-field fxFlex class="w-100-p">
    <mat-label>Emails</mat-label>
    <textarea [formControl]="batchUserSelectedEmails" matInput placeholder="Ex. toto@tutu.com;hell@titi.ca..." style="height:120px;min-height:100px"></textarea>
  </mat-form-field>
  <pre *ngIf="globalContext.debugMode">{{emailSelected}}</pre>

  <div fxFlex fxLayout class="mb-16">
    <span fxFlex="grow"></span>
    <button [disabled]="emailSelected.length===0" mat-button class="mat-primary" (click)="doSearch()">
      Search
    </button>
  </div>

  <div *ngIf="isSearching" fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
    <div>
      [searching....]
    </div>
  </div>
  <div *ngIf="!isSearching && localSearchResult.length === 0" fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
    <div>
      [No result]
    </div>
  </div>

  <div *ngIf="!isSearching" fxFlex="100" fxLayout="column" style="overflow: auto;">

    <div class="p-16" *ngFor="let result of localSearchResult">

      <mat-card class="list-item-card mb-8" [ngClass]="{'card-error': result.result.status !== 'COMPLETE'}">
        <mat-card-header>
          <mat-card-title>{{result.result?.recipient?.email || result.params.email}}</mat-card-title>
          <mat-card-subtitle *ngIf="result.result?.createdAt">{{result.result.createdAt | date: 'short'}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="!result.result.createdAt">{{result.result.timestamp | date: 'short'}}</mat-card-subtitle>
          <span fxFlex="grow"></span>
          <h2>{{result?.result?.status || 'ERROR'}}</h2>
        </mat-card-header>

        <mat-card-content *ngIf="result.result.status === 'COMPLETE'">

          <div fxLayout="column">
            <div fxFlex>
              <h2>Reward : {{result.result.rewardName}} / {{result.result.denomination.value}} {{result.result.denomination.currencyCode}}</h2>
            </div>

            <div fxFlex>
              <app-url-placeholder [url]="result.result.reward.credentials['Redemption Link']"></app-url-placeholder>
            </div>

          </div>

        </mat-card-content>

        <mat-card-content *ngIf="result.result.status !== 'COMPLETE'">

          <h2>{{result.result.httpCode}} - {{result.result.httpPhrase}}</h2>

          <div class="message-box error" *ngFor="let error of result.result.errors">
            {{error.path}} / {{error.message}}
          </div>

        </mat-card-content>

        <mat-accordion>
          <mat-expansion-panel *ngIf="result.result.status == 'COMPLETE'" [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Email received : {{result.result.emailSubject}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <h5>From: {{result.result.sender.firstName}} ({{result.result.sender.email}})</h5>
              <div [innerHTML]="result.result.message | safeHtml"></div>
            </ng-template>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Details
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <pre>{{result | json}}</pre>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>

      </mat-card>

    </div>


  </div>

</div>

